import React from 'react';
import { View } from 'react-native';
import Button from 'src/components/10-atoms/button/Button';
import SearchInput from 'src/components/10-atoms/form/inputs/SearchInput';
import Column from 'src/components/10-atoms/layout/Column';
import BottomDrawerLayout from 'src/components/20-helper-views/bottom-drawer/BottomDrawerLayout';
import EmptyList from 'src/components/templates/EmptyList.template';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import GQLPaginatedList from 'src/lib/graphql/components/GQLPaginatedList';
import NoteItem from 'src/modules/exam-preparation/containers/Notes/NoteItem';
import NotesListLoading from 'src/modules/exam-preparation/containers/Notes/NotesListLoading';
import useI18n from 'src/modules/translations/hooks/useI18n';
import styleUtils from 'src/utils/styles';
import useData from './useData';
const AttachNoteDrawer = ({ subjectID }) => {
    const [{ theme, styles }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const [state, actions] = useData(subjectID);
    return (React.createElement(BottomDrawerLayout, { yAxis: "flex-start", style: styleUtils.containerHeight },
        React.createElement(BottomDrawerLayout.Title, null, translate('Add Note')),
        React.createElement(Column, { flex: true, spacingY: theme.spacing.standard.md },
            React.createElement(SearchInput, { style: styles.searchInput, autoFocus: true, autoCorrect: false, autoCapitalize: "none", spellCheck: false, placeholder: translate('Search notes'), value: state.search.value, onChange: actions.search.change, onClear: () => actions.search.change('') }),
            React.createElement(GQLPaginatedList, { containerStyle: styleUtils.flex, contentContainerStyle: styles.listContentContainer, LoaderComponent: React.createElement(NotesListLoading, null), ListEmptyComponent: React.createElement(EmptyList, { message: translate('No notes found') }), queryState: state.listQuery, queryActions: actions.listQuery, variables: state.listQueryVariables, ItemSeparatorComponent: () => React.createElement(View, { style: styles.separator }), renderItem: ({ item }) => (React.createElement(NoteItem, { note: item, onPress: () => actions.setSelectedNoteID(item.id), style: [
                        state.selectedNoteID === item.id && styles.selectedNoteItem,
                    ] })) }),
            React.createElement(BottomDrawerLayout.Actions, { btw: 1, pv: theme.spacing.standard.sm },
                React.createElement(Button, { flex: true, disabled: !state.selectedNoteID, loading: state.addMutation.loading, onPress: actions.attachNote }, translate('Attach Note'))))));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    searchInput: {
        marginHorizontal: theme.spacing.standard.sm,
        marginTop: theme.spacing.standard.sm,
    },
    listContentContainer: {
        padding: theme.spacing.standard.sm,
    },
    separator: {
        height: theme.spacing.standard.sm,
    },
    selectedNoteItem: {
        borderWidth: 1,
        borderColor: theme.palette.primary.main,
    },
}));
export default AttachNoteDrawer;
